export const layoutEnemyRow = (
  count: number,
  areaRect: { x: number; y: number; width: number; height: number },
  avatarW: number,
  _avatarH: number,
  gap: number
): { x: number; y: number }[] => {
  if (count <= 0) {
    return [];
  }

  const usableWidth = Math.max(areaRect.width, avatarW);
  const totalWidth = count * avatarW + Math.max(0, count - 1) * gap;
  const startX = areaRect.x + Math.max(0, (usableWidth - totalWidth) / 2) + avatarW / 2;
  const centerY = areaRect.y + areaRect.height / 2;

  return Array.from({ length: count }, (_, index) => ({
    x: startX + index * (avatarW + gap),
    y: centerY,
  }));
};
